import { addHandlers, flowMax, SimplePropsAdder } from 'ad-hok'
import { UserWithImages } from 'shared/src/api/types'
import { addNavigate } from 'shared/src/utils/addNavigate'

import { ProfileViewType } from 'components/profile'

type AddNavigateToProfile = SimplePropsAdder<{
  navigateToProfile: (creator: Pick<UserWithImages, 'username'>) => void
}>

export const addNavigateToProfile: AddNavigateToProfile = flowMax(
  addNavigate,
  addHandlers(
    {
      navigateToProfile:
        ({ navigate }) =>
        ({ username }: Pick<UserWithImages, 'username'>) => {
          if (!username) {
            return
          }

          navigate(makeFluidCreatorUrl(username), {
            state: {
              showBackButton: true,
            },
          })
        },
    },
    ['navigate']
  )
)

export const makeFluidCreatorUrl = (creatorUsername: string | null) =>
  creatorUsername ? `/${creatorUsername}/posts` : '/'

export const makeFluidCreatorUrlWithMediaHash = ({
  creatorUsername,
  mediaId,
}: {
  creatorUsername: string
  mediaId: number
}) => `/${creatorUsername}/posts/rodeo#${mediaId}`

export const makeCreatorProfileUrl = (
  creatorUsername: string,
  view: ProfileViewType
) => `/${creatorUsername}/${view}`

export const makeMediaUrl = ({ mediaId }: { mediaId: number }) =>
  `/medias/${mediaId}`

export const makeProductDetailUrl = (
  productId: number,
  options?: { mediaId?: number; userListId?: number; creatorUsername: string }
) => {
  if (options) {
    const queryParams = new URLSearchParams()
    if (options.mediaId) {
      queryParams.append('mediaId', options.mediaId.toString())
    }
    if (options.userListId) {
      queryParams.append('userListId', options.userListId.toString())
    }
    queryParams.append('creator', options.creatorUsername)

    return `/products/${productId}?${queryParams}`
  } else {
    return `/products/${productId}`
  }
}

export const makeCreatorsUrlWithCategoryHash = (categoryHash: number) =>
  `/#${categoryHash}`

export const makeCategoryFeedUrl = (categoryId: number) =>
  `/categories/${categoryId}`

export const makeTagFeedUrl = (tagId: number) => `/tags/${tagId}`

export const makeRoundupUrl = () => '/roundup'

export const makeBrandUrl = (brandId: number) => `/brands/${brandId}`

export const makeLabelUrl = (labelId: number) => `/labels/${labelId}`

export const makeCreatorEditsUrl = (creatorUsername: string) =>
  `/${creatorUsername}/edits`

export const makeEditFeedUrl = (editId: number) => `/edits/${editId}`

export const makeRegisterUrl = (email?: string, attemptedLogin?: boolean) => {
  const queryParams = new URLSearchParams()
  if (email) {
    queryParams.append('user', email)
  }
  if (attemptedLogin) {
    queryParams.append('trigger', 'login')
  }

  return `/register?${queryParams}`
}

export const makeUserEditUrl = (editId: number, username: string) =>
  `/${username}/edits/${editId}`
